"use strict";
// Class definition
import Swiper, {Autoplay, EffectCreative, Lazy, Navigation, Pagination, Thumbs, Grid, EffectFade} from "swiper";
import Swal from 'sweetalert2'
import SwiperAnimation from '@cycjimmy/swiper-animation';
import ma5menu from "./ma5-menu";
import {Modal} from 'bootstrap';
import WOW from 'wow.js';
import {CountUp} from "countup.js";
import SVGInject from '@iconfu/svg-inject';
import Cookies from 'js-cookie';
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

var MainScripts = function () {
    let swiperAnimation;
    jQuery.fn.exists = function () {
        return this !== null && this !== undefined;
    }

    function loadScript(url, callback) {
        const createScript = (src, onLoad) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = src;
            script.onload = onLoad;
            document.head.appendChild(script);
        };

        if (typeof url === 'string') {
            createScript(url, () => setTimeout(callback, 50));
        } else {
            let loadCount = 0;
            const totalScripts = url.length;
            url.forEach(src => {
                createScript(src, () => {
                    loadCount++;
                    if (loadCount === totalScripts && callback) {
                        setTimeout(callback, 50);
                    }
                });
            });
        }
    }

    var swiperUse = function () {
        Swiper.use([Navigation, Pagination, Lazy, EffectCreative, Autoplay, Thumbs, Grid, EffectFade]);
        swiperAnimation = new SwiperAnimation();
    }

    var homeSwipers = function () {


        var interleaveOffset = 0.5;

        let videos = document.querySelectorAll('.home-slider .swiper-slide video');
        videos.forEach(function ($el) {
            let ths = $el;
            let load = setInterval(function () {
                if (ths.readyState >= 1) {
                    let duration = (ths.duration * 1000) - 1000
                    if (duration > 0) {
                        ths.closest(".swiper-slide").setAttribute('data-swiper-autoplay', duration);

                        setTimeout(function () {
                            let index = Object.values(document.querySelectorAll('.home-slider .swiper-slide')).indexOf(ths.parentElement.parentElement);
                            $(".pagination-navigation .pagination .swiper-pagination-bullet").eq(index)
                                .find('.active-line').css("animation-duration", (duration + 1000) + 'ms');
                        }, 500)
                    }
                    clearInterval(load);
                }
            }, 100)
        });

        setTimeout(function () {
            const home_slider = new Swiper('.home-slider', {
                // loop: true,
                speed: 1000,
                grabCursor: true,
                watchSlidesProgress: true,
                mousewheelControl: true,
                keyboardControl: true,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.home-slider-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        index += 1;
                        return `<span class="${className}">${(index < 10 ? '0' + index : index)}</span>`;
                    }
                },
                on: {
                    progress: function (swiper, progress) {
                        for (var i = 0; i < swiper.slides.length; i++) {
                            var slideProgress = swiper.slides[i].progress;
                            var innerOffset = swiper.width * interleaveOffset;
                            var innerTranslate = slideProgress * innerOffset;
                            if (swiper.slides[i].querySelector(".slide-background"))
                                swiper.slides[i].querySelector(".slide-background").style.transform =
                                    "translate3d(" + innerTranslate + "px, 0, 0)";
                        }
                    },
                    touchStart: function () {
                        var swiper = this;
                        for (var i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = "";
                        }
                    },
                    setTransition: function (swiper, speed) {
                        for (var i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = speed + "ms";
                            if (swiper.slides[i].querySelector(".slide-background"))
                                swiper.slides[i].querySelector(".slide-background").style.transition =
                                    speed + "ms";
                        }
                    },
                    init: function () {
                        swiperAnimation.init(this).animate();

                        var currentVideo = $("[data-swiper-slide-index=" + this.realIndex + "]").find("video");
                        currentVideo.trigger('play');

                    },
                    slideChange: function (swiper) {
                        const activeIndex = swiper.activeIndex;
                        const media = swiper.slides[activeIndex].querySelector('[slide-src]');

                        if (media && media.hasAttribute('slide-src')) {
                            media.setAttribute('src', media.getAttribute('slide-src'));
                            media.removeAttribute('slide-src');
                        }

                        const picture = swiper.slides[activeIndex].querySelector('picture');
                        console.log(picture)
                        if (picture) {
                            console.log(picture)
                            if (picture.querySelector('img') === null) {
                                const img = document.createElement('img');
                                img.classList.add('w-100', 'h-100', 'slide-background');
                                picture.appendChild(img);
                            }
                        }

                        swiperAnimation.init(this).animate();

                        videos.forEach(function (ths) {
                            ths.currentTime = 0;
                        });
                        var prevVideo = $("[data-swiper-slide-index=" + this.previousIndex + "]").find("video");
                        var currentVideo = $("[data-swiper-slide-index=" + this.realIndex + "]").find("video");
                        prevVideo.trigger('stop');
                        currentVideo.trigger('play');
                    }
                }
            });
        }, 500);

        new Swiper(".stats-swiper", {
            spaceBetween: 20,
            slidesPerView: 3,
            slidesPerGroup: 3,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false
            // },
            pagination: {
                el: '.stats .swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                480: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1540: {
                    spaceBetween: 70
                }
            }
        });
    }

    const scrollToAlert = () => {
        setTimeout(function () {
            let alert = $('.alert');
            if (alert.exists()) {
                let offset = alert.offset();
                let top = offset.top;
                window.scrollTo({
                    top: top,
                    behavior: '  smooth'
                });
            }
        }, 300)
    }

    var otherSwipers = function () {

        if ($('.showcase-products .swiper').exists()) {
            new Swiper('.showcase-products .swiper', {
                slidesPerView: 5,
                spaceBetween: 20,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.showcase-products .swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    576: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: 3
                    },
                    1200: {
                        slidesPerView: 4
                    },
                    1540: {
                        slidesPerView: 5
                    }
                }
            });
        }

        if ($('.showcase-blogs .swiper').exists()) {
            new Swiper('.showcase-blogs .swiper', {
                slidesPerView: 1,
                spaceBetween: 20,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.showcase-blogs .swiper-pagination',
                    clickable: true,
                },
            });
        }


        if ($('.catalogs .swiper').exists()) {
            new Swiper('.catalogs .swiper', {
                slidesPerView: 1,
                autoplay: {
                    delay: 7000,
                },
                pagination: {
                    el: '.catalogs .swiper-pagination',
                    clickable: true,
                }

            });
        }

        if ($('.product-detail .images .swiper').exists()) {
            new Swiper('.product-detail .images .swiper', {
                slidesPerView: 1,
                speed: 1000,
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                    el: '.product-detail .images .swiper-pagination',
                    clickable: true,
                }
            });
        }

        if ($('.other-products .swiper').exists()) {
            new Swiper('.other-products .swiper', {
                slidesPerView: 5,
                slidesPerGroup: 5,
                spaceBetween: 20,
                speed: 1000,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.other-products .swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                    },
                    1540: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                    }

                }

            })
        }
        if ($('.other-posts .swiper').exists()) {
            new Swiper('.other-posts .swiper', {
                slidesPerView: 5,
                slidesPerGroup: 5,
                spaceBetween: 80,
                speed: 1000,
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 40,
                    },
                    1200: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 60,
                    },
                    1540: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                        spaceBetween: 80,
                    }
                }

            })
        }
    }


    var formPOST = function () {
        let forms = document.querySelectorAll('form[method="post"]:not(.no-ajax)');
        if (forms.length > 0) {
            forms.forEach(function (el) {
                el.addEventListener('submit', function (e) {
                    e.preventDefault();
                    let form = this;
                    form.querySelector('button[type="submit"]').setAttribute('disabled', 'disabled');
                    Swal.fire({
                        title: window.lang.formSendingText,
                        icon: 'info',
                    }).then(() => {
                    });
                    form.submit();
                })
            });
        }
    }


    var getKvKK = function () {
        if (document.querySelectorAll('.kvkk')) {
            document.querySelectorAll('.kvkk').forEach(function (el) {
                el.addEventListener('click', function () {
                    fetch(window.siteurl + '/kvkk', {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Data-Type': 'application/json'
                        }
                    }).then((response) => response.json())
                        .then((data) => {
                            const myModal = CreateModal(data);
                            myModal.show();
                        }).catch((error) => {
                        console.error('Error:', error);
                        Swal.fire({
                            icon: 'error',
                            title: window.lang.formError
                        }).then(() => {
                        })
                    });
                });
            })
        }
    }


    function CreateModal(dt) {
        let id = '#kvkk-' + dt.id;
        let element = document.getElementById(id);
        if (typeof (element) != 'undefined' && element != null) {
            $(id).find("#ModalLabel").text(dt.title);
            $(id).find("#ModalContent").html(dt.description);
        } else {
            $('body').append('<div class="modal fade" id="' + id + '" tabindex="-1">\n' +
                '  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl kvkk-modal">\n' +
                '    <div class="modal-content">\n' +
                '      <div class="modal-header">\n' +
                '        <h5 class="modal-title" id="ModalLabel">' + dt.title + '</h5>\n' +
                '        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Kapat"></button>\n' +
                '      </div>\n' +
                '      <div class="modal-body" id="ModalContent"><div class="page-content">\n' + dt.description +
                '      </div>\n' +
                '      </div>\n' +
                '      <div class="modal-footer">\n' +
                '        <button type="button" class="btn btn-secondary text-white" data-bs-dismiss="modal">' + window.lang.closeButton + '</button>\n' +
                '      </div>\n' +
                '    </div>\n' +
                '  </div>\n' +
                '</div>');
            element = document.getElementById(id);
        }
        return new Modal(element, {});
    }

    var contacts = function () {

        $('.whatsapp_bubble').on('click', function () {
            if ($('.whatsapp_pp').hasClass('active')) {
                $('.whatsapp_pp').removeClass('active')
            } else {
                $('.whatsapp_pp').addClass('active')
            }
        });

        setTimeout(function () {
            $('.whatsapp_bubble').trigger('click');
        }, 30000);


        $('.whatsapp_pp .close_pp').on('click', function () {
            $('.whatsapp_pp').removeClass('active')
        });
    }

    var mobilMenu = function () {

        if (window.innerWidth < 1101) {
            $('.ma5menu__panel ul li svg,.ma5menu__panel ul li img').remove();
            $('.ma5menu__panel ul li a').each(function () {
                const $this = $(this);
                if ($this.html().replace(/\s|&nbsp;/g, '').length === 0)
                    $this.remove();
            });
            $('.site-menu li .header-menu-item').remove();
        }

        ma5menu({
            menu: '.site-menu',
            activeClass: 'active',
            footer: '#ma5menu-tools',
            position: 'left',
            closeOnBodyClick: true
        });
    }

    var observer = function () {

        const observer = new IntersectionObserver(entries => {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.classList.add('loaded');
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazy");
                    observer.unobserve(lazyImage);
                }
            });
        }, {
            rootMargin: "0px"
        });

        $(function () {
            let srcItems = document.querySelectorAll('[data-src]');
            srcItems.forEach(box => {
                observer.observe(box);
            });
        })
    }

    var onload = function () {

        const lazyBackgroundImages = document.querySelectorAll('.lazy-bg');


        const imageObserver = new IntersectionObserver((entries, imageObserver) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    showImageBackground(entry.target);
                    imageObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0,
            rootMargin: "0px 0px 50px 0px"
        });

        lazyBackgroundImages.forEach(image => {
            imageObserver.observe(image);
        });

        function showImageBackground(node) {
            node.classList.remove('lazy-bg');
        }

        var wow = new WOW(
            {
                boxClass: 'wow',
                animateClass: 'animate__animated',
                offset: 0,
                mobile: true,
                live: true,
                scrollContainer: null,
                resetAnimation: true,
            }
        );

        wow.init();

        $('[data-wow]').each(function () {
            var $delay = 0;
            var $defaultAnimation = $(this).data("wow");
            if (!$defaultAnimation.toString().length) {
                $defaultAnimation = "animate__fadeInUp";
            }
            $(this).children().each(function (element, index) {
                var $ths = $(index);
                var $animation = $defaultAnimation;
                if ($ths.data("animation")) {
                    $animation = $ths.data("animation");
                }
                $ths.addClass("wow");
                $ths.addClass($animation);
                $ths.attr("data-wow-duration", ".5s");
                $ths.attr("data-wow-delay", $delay + "s")
                $delay = $delay + 0.2;
            })
        })

        SVGInject(document.querySelectorAll('img.svg-inject'));

        $('.close-sidebar, .widget-backdrop').click(function () {
            $('.mobile-menu-btn').trigger('click');
        });

        $('.mobile-menu-btn').on('click', function () {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
                $(this).find('svg').html('<use xlink:href="/assets/images/sprite.svg#times"></use>')
                $(this).parents('aside').addClass('sidebar-active');
            } else {
                $(this).removeClass('active');
                $(this).find('svg').html('<use xlink:href="/assets/images/sprite.svg#bars-light"></use>')
                $(this).parents('aside').removeClass('sidebar-active');
            }
        });


        $('header .contact-phones').hover(() => {
            $("header .contact-phones .list").slideDown();
        }, () => {
            $("header .contact-phones .list").slideUp();
        })

        if ($('#filterForm').exists()) {
            document.getElementById('filterForm').onchange = function () {
                this.submit();
            }
        }

        // Site Menu Magic Line
        var $el, leftPos, newWidth,
            $mainNav = $(".site-menu");

        $mainNav.append("<div id='magic-line'></div>");
        var $borderLine = $("#magic-line");

        if ($mainNav.find('li').hasClass('active') === false) {
            $mainNav.find('li').first().addClass('active');
        }

        $borderLine
            .width($(".site-menu > li.active").outerWidth())
            .css("left", $mainNav.find('li.active').position().left)
            .data("origLeft", $borderLine.position().left)
            .data("origWidth", $borderLine.width());

        $(".site-menu > li").hover(function () {
            $el = $(this);
            leftPos = $el.position().left;
            newWidth = $el.outerWidth();
            $borderLine.stop().animate({
                left: leftPos,
                width: newWidth
            });
        }, function () {
            $borderLine.stop().animate({
                left: $borderLine.data("origLeft"),
                width: $borderLine.data("origWidth")
            });
        });

        if (window.location.hash) {
            let id = window.location.hash;
            let tab = document.querySelector('a[href="' + id + '"]');
            if (tab)
                tab.click();
        }

        document.querySelectorAll('.footer-item .calculators li a').forEach((el) => {
            el.addEventListener('click', () => {
                let id = '#' + el.getAttribute('href').split('#')[1];
                console.log(id)
                let tabs = document.querySelectorAll('#list-tab a');
                let tabContents = document.querySelectorAll('#nav-tabContent .tab-pane');
                let tab = document.querySelector('a[href="' + id + '"]');
                let tabContent = document.querySelector(id);
                if (tab && tabContent) {
                    tabs.forEach((el) => {
                        if (el !== tab)
                            el.classList.remove('active');
                    })
                    tabContents.forEach((el) => {
                        if (el !== tabContent)
                            el.classList.remove('show', 'active');
                    })

                    tab.classList.add('active');
                    tabContent.classList.add('show', 'active');
                }
            })
        })


        $('.list-group-item-action').on('click', function () {
            var currentTab = $(this).attr('href');

            $('.tab-content .tab-pane').not(currentTab).find('input').val('');

            document.getElementById('waterHeatingFormResult').textContent = "KW : -";
            document.getElementById('moldHeatingFormResult').textContent = "KW : -";
            document.getElementById('resistorFormResult').textContent = window.lang.resistor + ' : -';
            document.getElementById('voltFormResult').textContent = window.lang.volt + ' : -';
            document.getElementById('ampereFormResult').textContent = window.lang.ampere + ' : -';
            document.getElementById('ampere2FormResult').textContent = window.lang.ampere + ' : -';
            document.getElementById('waterHeatingFormClear').style.display = 'none';
            document.getElementById('moldHeatingFormClear').style.display = 'none';
            document.getElementById('resistorFormClear').style.display = 'none';
            document.getElementById('voltFormClear').style.display = 'none';
            document.getElementById('ampereFormClear').style.display = 'none';
            document.getElementById('ampere2FormClear').style.display = 'none';
        });

        document.addEventListener('click', (event) => {
            let clickedEl = event.target;

            if (clickedEl.tagName === "INPUT" || clickedEl.type === "TEXTAREA" || clickedEl.type === "SELECT") {
                var script = document.createElement('script');
                script.src = "https://www.google.com/recaptcha/api.js";
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            }
        })
    }

    const cvUpload = () => {
        $('.cv-upload').on('click', function () {
            let input = $(this).closest('form').find('input[type="file"]');
            input.trigger('click');
        });


        $('input[type="file"][name="cv"]').on('change', function () {
            let filename = $(this).val().split('\\').pop();
            $('form .cv').addClass('d-none');
            let $temp = `<div class="file">${filename}</div>
                        <button type="button" class="btn btn-sm btn-danger rounded-2 ms-auto" data-cvdelete=""><svg class="cvzicon"><use xlink:href="/assets/images/sprite.svg#times"></use></svg></button>`
            // $(this).closest('form').find('.cv-upload').html(filename);

            let size = this.files[0].size;
            if (size > 16777216) {
                Swal.fire({
                    icon: 'warning',
                    html: lang.formCVSizeLimit,
                    showConfirmButton: true,
                    confirmButtonText: lang.closeButton,
                    confirmButtonColor: '#ffb100'
                })
                $(this).val('');
                return;
            }

            let ext = filename.split('.').pop();
            ext = ext.toLowerCase();
            if (ext != 'pdf' && ext != 'doc' && ext != 'docx' && ext != 'jpg' && ext != 'jpeg' && ext != 'png') {
                Swal.fire({
                    icon: 'warning',
                    html: lang.formCVFileExtension,
                    showConfirmButton: true,
                    confirmButtonText: lang.closeButton,
                    confirmButtonColor: '#ffb100'
                })
                $(this).val('');
                return;
            }

            $('form .cv').removeClass('d-none').html($temp);
        });

        $(document).on('click', '.cv [data-cvdelete]', function () {
            $(this).closest('form').find('input[type="file"][name="cv"]').val('');
            $(this).closest('.cv').html('').addClass('d-none');
            $('form .cv-upload').html(lang.formCVUpload);
        });
    }
    var countUp = function () {
        function isScrolledIntoView(el) {
            var elemTop = el.getBoundingClientRect().top;
            var elemBottom = el.getBoundingClientRect().bottom;

            var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
            return isVisible;
        }

        if (document.querySelectorAll('.count').length > 0) {
            var firstScrolled = false;
            window.addEventListener('scroll', function () {
                if (!firstScrolled) {
                    if (isScrolledIntoView(document.querySelector('.count'))) {
                        document.querySelectorAll('.count').forEach(function (el) {
                            let count = new CountUp(el, el.getAttribute('data-end'));
                            if (!count.error) {
                                count.start();
                            } else {
                                console.error(count.error);
                            }
                        });
                        firstScrolled = true;
                    }
                }
            }, true);
        }
    }


    var calcForms = function () {
        var waterHeating = function () {
            if ($('#waterHeatingForm').exists()) {
                const literInput = document.getElementById('waterHeatingFormLiterInput');
                const betweenDegreesInput = document.getElementById('waterHeatingFormBetweenDegreesInput');
                const timeInput = document.getElementById('waterHeatingFormTimeInput');
                const form = document.getElementById('waterHeatingForm');
                const clearButton = document.getElementById('waterHeatingFormClear');

                [literInput, betweenDegreesInput, timeInput].forEach(input => {
                    input.addEventListener('input', function () {
                        if (literInput.value && betweenDegreesInput.value && timeInput.value) {
                            form.dispatchEvent(new Event('submit'));
                        } else {
                            document.getElementById('waterHeatingFormResult').textContent = "KW : -";
                        }

                        if (literInput.value || betweenDegreesInput.value || betweenDegreesInput.value || timeInput.value) {
                            clearButton.style.display = 'flex';
                        } else {
                            clearButton.style.display = 'none';
                            document.getElementById('waterHeatingFormResult').textContent = "KW : -";
                        }

                    });
                });

                clearButton.addEventListener('click', function () {
                    form.reset();
                    clearButton.style.display = 'none';
                    document.getElementById('waterHeatingFormResult').textContent = "KW : -";
                });


                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var liter = parseFloat(literInput.value);
                    var betweenDegrees = parseFloat(betweenDegreesInput.value);
                    var time = parseFloat(timeInput.value);
                    var result = (liter * betweenDegrees) / (603.9 * time);
                    document.getElementById('waterHeatingFormResult').textContent = "KW : " + result;
                });
            }
        }
        waterHeating();

        var moldHeating = function () {
            if ($('#moldHeatingForm').exists()) {
                const massInput = document.getElementById('moldHeatingFormMassInput');
                const specificHeatInput = document.getElementById('moldHeatingFormSpecificHeatInput');
                const betweenDegreesInput = document.getElementById('moldHeatingFormBetweenDegreesInput');
                const timeInput = document.getElementById('moldHeatingFormTimeInput');
                const form = document.getElementById('moldHeatingForm');
                const clearButton = document.getElementById('moldHeatingFormClear');

                [massInput, specificHeatInput, betweenDegreesInput, timeInput].forEach(input => {
                    input.addEventListener('input', function () {
                        if (massInput.value && specificHeatInput.value && betweenDegreesInput.value && timeInput.value) {
                            form.dispatchEvent(new Event('submit'));
                        } else {
                            document.getElementById('moldHeatingFormResult').textContent = "KW : -";
                        }

                        if (massInput.value || specificHeatInput.value || betweenDegreesInput.value || timeInput.value) {
                            clearButton.style.display = 'flex';
                        } else {
                            clearButton.style.display = 'none';
                            document.getElementById('moldHeatingFormResult').textContent = "KW : -";
                        }
                    });
                });


                clearButton.addEventListener('click', function () {
                    form.reset();
                    clearButton.style.display = 'none';
                    document.getElementById('moldHeatingFormResult').textContent = "KW : -";
                });

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var mass = parseFloat(massInput.value);
                    var specificHeat = parseFloat(specificHeatInput.value);
                    var betweenDegrees = parseFloat(betweenDegreesInput.value);
                    var time = parseFloat(timeInput.value);
                    var result = (mass * specificHeat * betweenDegrees) / (860 * time);
                    document.getElementById('moldHeatingFormResult').textContent = "KW : " + result;
                });
            }
        }
        moldHeating();

        var resistor = function () {
            if ($('#resistorForm').exists()) {
                const voltInput = document.getElementById('resistorFormVoltInput');
                const wattInput = document.getElementById('resistorFormWattInput');
                const form = document.getElementById('resistorForm');
                const clearButton = document.getElementById('resistorFormClear');

                [voltInput, wattInput].forEach(input => {
                    input.addEventListener('input', function () {
                        if (voltInput.value && wattInput.value) {
                            form.dispatchEvent(new Event('submit'));
                        } else {
                            document.getElementById('resistorFormResult').textContent = window.lang.resistor + ' : -';
                        }

                        if (voltInput.value || wattInput.value) {
                            clearButton.style.display = 'flex';
                        } else {
                            clearButton.style.display = 'none';
                            document.getElementById('resistorFormResult').textContent = window.lang.resistor + ' : -';
                        }

                    });
                });


                clearButton.addEventListener('click', function () {
                    form.reset();
                    clearButton.style.display = 'none';
                    document.getElementById('resistorFormResult').textContent = window.lang.resistor + ' : -';
                });

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var volt = parseFloat(voltInput.value);
                    var watt = parseFloat(wattInput.value);
                    var result = (volt * volt) / watt;
                    document.getElementById('resistorFormResult').textContent = window.lang.resistor + ' : ' + result;
                });
            }
        }
        resistor();

        var volt = function () {
            if ($('#voltForm').exists()) {
                const ampereInput = document.getElementById('voltFormAmpereInput');
                const resistorInput = document.getElementById('voltFormResistorInput');
                const form = document.getElementById('voltForm');
                const clearButton = document.getElementById('voltFormClear');

                [ampereInput, resistorInput].forEach(input => {
                    input.addEventListener('input', function () {
                        if (ampereInput.value && resistorInput.value) {
                            form.dispatchEvent(new Event('submit'));
                        } else {
                            document.getElementById('voltFormResult').textContent = window.lang.volt + ' : -';
                        }

                        if (ampereInput.value || resistorInput.value) {
                            clearButton.style.display = 'flex';
                        } else {
                            clearButton.style.display = 'none';
                            document.getElementById('voltFormResult').textContent = window.lang.volt + ' : -';
                        }
                    });
                });

                clearButton.addEventListener('click', function () {
                    form.reset();
                    clearButton.style.display = 'none';
                    document.getElementById('voltFormResult').textContent = window.lang.volt + ' : -';
                });

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var ampere = parseFloat(ampereInput.value);
                    var resistor = parseFloat(resistorInput.value);
                    var result = ampere * resistor;
                    document.getElementById('voltFormResult').textContent = window.lang.volt + ' : ' + result;
                });

            }
        }
        volt();

        var ampere = function () {
            if ($('#ampereForm').exists()) {
                const voltInput = document.getElementById('ampereFormVoltInput');
                const resistorInput = document.getElementById('ampereFormResistorInput');
                const form = document.getElementById('ampereForm');
                const clearButton = document.getElementById('ampereFormClear');

                [voltInput, resistorInput].forEach(input => {
                    input.addEventListener('input', function () {
                        if (voltInput.value && resistorInput.value) {
                            form.dispatchEvent(new Event('submit'));
                        } else {
                            document.getElementById('ampereFormResult').textContent = window.lang.ampere + ' : -';
                        }

                        if (voltInput.value || resistorInput.value) {
                            clearButton.style.display = 'flex';
                        } else {
                            clearButton.style.display = 'none';
                            document.getElementById('ampereFormResult').textContent = window.lang.ampere + ' : -';
                        }
                    });
                });

                clearButton.addEventListener('click', function () {
                    form.reset();
                    clearButton.style.display = 'none';
                    document.getElementById('ampereFormResult').textContent = window.lang.ampere + ' : -';
                });

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var volt = parseFloat(voltInput.value);
                    var resistor = parseFloat(resistorInput.value);
                    var result = volt / resistor;
                    document.getElementById('ampereFormResult').textContent = window.lang.ampere + ' : ' + result;
                });
            }
        }
        ampere();

        var ampere2 = function () {
            if ($('#ampere2Form').exists()) {
                const wattInput = document.getElementById('ampere2FormWattInput');
                const voltInput = document.getElementById('ampere2FormVoltInput');
                const form = document.getElementById('ampere2Form');
                const clearButton = document.getElementById('ampere2FormClear');

                [wattInput, voltInput].forEach(input => {
                    input.addEventListener('input', function () {
                        if (wattInput.value && voltInput.value) {
                            form.dispatchEvent(new Event('submit'));
                        } else {
                            document.getElementById('ampere2FormResult').textContent = window.lang.ampere + ' : -';
                        }

                        if (wattInput.value || voltInput.value) {
                            clearButton.style.display = 'flex';
                        } else {
                            clearButton.style.display = 'none';
                            document.getElementById('ampere2FormResult').textContent = window.lang.ampere + ' : -';
                        }
                    });
                });

                clearButton.addEventListener('click', function () {
                    form.reset();
                    clearButton.style.display = 'none';
                    document.getElementById('ampere2FormResult').textContent = window.lang.ampere + ' : -';
                });

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    var watt = parseFloat(wattInput.value);
                    var volt = parseFloat(voltInput.value);
                    var result = watt / volt;
                    document.getElementById('ampere2FormResult').textContent = window.lang.ampere + ' : ' + result;
                });
            }
        }
        ampere2();
    }


    return {
        init: function () {
            Fancybox.bind("[data-fancybox]", {});

            observer();
            swiperUse();
            homeSwipers();
            otherSwipers();
            getKvKK();
            scrollToAlert();
            countUp();
            calcForms();
            formPOST();
            mobilMenu();
            contacts();
            cvUpload();
            onload();


        },
    };
}();

// On document ready
jQuery(document).ready(function () {

    MainScripts.init();

});